class QuinceError extends Error {
    capture(hint) {
    // TODO
    }
    constructor(errorDetails){
        super(errorDetails.message, errorDetails.options), this.data = undefined;
        this.name = errorDetails.name;
        this.data = errorDetails.data;
    }
}

export { QuinceError as default };
//# sourceMappingURL=quince-error.js.map
